// src/services/messages.js
import api from './api';

const messageService = {

  
  // Récupérer les conversations
  getConversations: async (userId) => {
    try {
      const response = await api.get('/get-conversations.php', {
        params: { user_id: userId }
      });
      return response.data;
    } catch (error) {
      console.error('❌ Erreur getConversations:', error);
      return { success: false, conversations: [] };
    }
  },

  // Récupérer les messages d'une conversation
  getMessages: async (currentUserId, otherUserId) => {
    try {
      const response = await api.get('/get-messages.php', {
        params: {
          current_user_id: currentUserId,
          user_id: otherUserId
        }
      });
      return response.data.success ? response.data.messages : [];
    } catch (error) {
      console.error('❌ Erreur getMessages:', error);
      return [];
    }
  },

  // Envoyer un message
  sendMessage: async (senderId, receiverId, message) => {
    try {
      const params = new URLSearchParams();
      params.append('sender_id', senderId.toString());
      params.append('receiver_id', receiverId.toString());
      params.append('message', message);
      
      const response = await api.post('/send-message.php', params);
      return response.data;
    } catch (error) {
      console.error('❌ Erreur sendMessage:', error);
      return { success: false };
    }
  },

  // Envoyer un média
  sendMedia: async (senderId, receiverId, file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('sender_id', senderId.toString());
      formData.append('receiver_id', receiverId.toString());
      
      const response = await api.post('/upload-chat-media.php', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error) {
      console.error('❌ Erreur sendMedia:', error);
      return { success: false };
    }
  },

  // Indicateur de frappe


  // Indicateur de frappe - Version avec logs
   setTyping: async (senderId, receiverId, isTyping) => {
    try {
      console.log('📤 Envoi setTyping:', { senderId, receiverId, isTyping });
      
      // Créer les données au format URLSearchParams
      const params = new URLSearchParams();
      params.append('sender_id', senderId.toString());
      params.append('receiver_id', receiverId.toString());
      params.append('is_typing', isTyping ? '1' : '0');
      
      const response = await api.post('/set-typing.php', params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        }
      });
      
      console.log('📥 Réponse setTyping:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Erreur setTyping:', error);
      return { success: false };
    }
  },

  // Vérifier si l'autre utilisateur écrit
  checkTyping: async (currentUserId, otherUserId) => {
    try {
      const response = await api.get('/get-typing.php', {
        params: {
          current_user_id: currentUserId,
          other_user_id: otherUserId
        }
      });
      return response.data;
    } catch (error) {
      console.error('❌ Erreur checkTyping:', error);
      return { success: false, is_typing: false };
    }
  },





  // Vérifier les nouveaux messages
  checkNewMessages: async (currentUserId, otherUserId, lastMessageId) => {
    try {
      const params = new URLSearchParams();
      params.append('current_user_id', currentUserId.toString());
      params.append('user_id', otherUserId.toString());
      params.append('last_id', lastMessageId.toString());
      
      const response = await api.post('/get-last-messages.php', params);
      return response.data;
    } catch (error) {
      console.error('❌ Erreur checkNewMessages:', error);
      return { success: false, messages: [], isTyping: false };
    }
  },

  // Marquer les messages comme lus
  markAsRead: async (currentUserId, otherUserId) => {
    try {
      const response = await api.post('/mark-messages-read.php', {
        user_id: currentUserId,
        other_user_id: otherUserId
      });
      return response.data;
    } catch (error) {
      console.error('❌ Erreur markAsRead:', error);
      return { success: false };
    }
  }
};

export default messageService;